<script setup>
import QuoteForm from './QuoteForm.vue';
import axios from '/node_modules/axios';
import { useStore } from 'vuex';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
const overlay = ref(null);
const loader = ref(null);
const quoteForm = ref(null);

const quoteFormVisible = ref(false);

function edit() {
  document.getElementById("details").scrollIntoView({behavior: 'smooth'});
  store.commit('updateQuotes', []);
}

function openPayment(event, quantity, price, total, index) {
  store.commit('updateItem', {
    price: price,
    quantity: quantity,
    total: total,
    index: index
  });
  router.push('/payment');
}

let email_popup;

function items() {
  return store.getters.quotes;
}
</script>

<template>
  <div class="pb-3 px-1">
    <div class="overlay" ref="overlay" id="overlay" :style="{ display: store.state.quotes.length > 0 ? 'none' : 'block' }">
      <div class="loading" ref="loader" id="loading-animation" :style="{ display: store.state.loading ? 'block' : 'none', visibility: store.state.loading ? 'visible' : 'hidden' }">
      </div>
    </div>
    <h2 class="text-lg-center" id="results">Your Results</h2>

    <div id="estimate-results-form">

      <div style="width: 100%;margin-top:35px">
        <ul>
            <li>
              <div style="display:flex;width:100%">
                <div class="div-table-header"><p>Quantity</p></div>
                <div class="div-table-header"><p>Cost per Spring</p></div>
                <div class="div-table-header"><p>Spring Total</p></div>
                <div class="div-table-header"><p>BUY</p></div>
              </div>
          </li>
        </ul>
        <ul>
          <li v-for="(item, index) in items()" :key="index" class="results">
            <div style="width:100%;display:flex" v-if="item.quantity !== 0">
              <div class="div-table-cell" :aria-label="'Quantity: ' + item.quantity">{{ item.quantity }}</div>
              <div class="div-table-cell" :aria-label="'Price: ' + item.price"><p v-show="item.price == null  ? false : true" class="font-weight-normal">$</p>{{ item.price }}</div>
              <div class="div-table-cell" :aria-label="'Total: ' + item.total"><p v-show="item.total == null  ? false : true" class="font-weight-normal">$</p>{{ item.total }}</div>
              <div class="div-table-cell">
                <button 
                  @click="(event) => openPayment(event, item.quantity, item.price, item.total, index )" 
                  class="w-100 btn btn-secondary text-white" :id="index" aria-description="Buy {{ item.quantity }} Custom Spring at {{ item.price }} per spring for a total of {{ item.total }}">BUY</button></div>
            </div>
          </li>
        </ul>
      </div>

    </div>

    <div id="estimate-results-form-mobile">
      <div v-for="(item, index) in items()" :key="index" class="w-100" style="margin-bottom: 35px;">
        <div class="div-table-cell-mobile d-flex justify-content-evenly align-items-stretch" v-if="item.quantity !== 0">
          <div class="mobile-table ">
            <label>Quantity</label>
          </div>
          <div class="mobile-result">
            <p :id="'quantity_' + index + '_quantity_mobile'">{{ item.quantity }}</p>
          </div>
        </div>
        <div class="div-table-cell-mobile d-flex justify-content-evenly align-items-stretch" v-if="item.quantity !== 0">
          <div class="mobile-table">
            <label>Cost Per Spring</label>
          </div>
          <div class="mobile-result" >
            <p :id="'quantity_' + index + '_price_mobile'"><span v-show="item.price == null  ? false : true" class="font-weight-normal">$</span>{{ item.price }}</p>
          </div>
        </div>
        <div class="div-table-cell-mobile d-flex justify-content-evenly align-items-stretch border-bottom" v-if="item.quantity !== 0">
          <div class="mobile-table">
            <label>Spring Total</label>
          </div>
          <div class="mobile-result">
            <p :id="'quantity_' + index + '_total_mobile'"><span v-show="item.total == null  ? false : true" class="font-weight-normal">$</span>{{ item.total }}</p>
          </div>
        </div>
        <div class="col-12 my-2" v-if="item.quantity !== 0">

          <!-- <button @click="generateQuote" class="btn btn-outline-primary me-2" :id="'mq' + index" >Get Quote</button> -->
          <button @click="(event) => openPayment(event, item.quantity, item.price, item.total, index )" class="btn btn-secondary text-white ms-2" :id="'m' + index">BUY</button>

        </div>
      </div>
    </div>

    <div class="my-3 d-flex mobile-margin">
        <button @click="edit" class="btn btn-outline-secondary" id="edit">&lt;&lt; EDIT DETAILS</button>
        <button @click="store.commit('toggleQuote')" aria-description="opens specsheet popup window" class="btn btn-primary mx-3 text-uppercase">Specsheet</button>
        <div class="font-weight-normal">
          <p><span class="font-weight-bold" style="color:red">Lead Time:</span> {{ store.state.leadTime }} to Ship</p>
          <p class="font-weight-bold text-left">Free Shipping</p>
        </div>
      </div>
      <div class="hide-on-mobile mt-4" style="background-image:url('/wp-content/uploads/2024/04/CompressionSpringDiagramforQuoter-1.png');background-size:contain;background-position:center center;height:165px;width:100%;background-repeat:no-repeat">

</div>
    <div class="d-flex align-items-center justify-content-center w-100 hide-on-mobile">
      <a class="text-capitalize font-weight-bold mt-3" target='_blank' href="/products/compression-springs/guide-to-measuring-compression-springs/">View our measuring guide</a>
    </div>

  </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@media (max-width: 1000px) {
  .hide-on-mobile {
    display: none !important;
  }
  .mobile-margin {
    margin-bottom: 75px !important;
  }
}
div {
  position: relative;

  .overlay {
    position: absolute;
    background-color: rgba(299, 299, 299, .8);
    z-index: 999;
    position: absolute;
    left:0;
    top:0;
    right:0;
    bottom:245px;
    display:flex;
    align-items:center;
    justify-content: center;

    .loading {
      background-image: url('https://springsfast.com/custom-springs-app/public/spring_loading.gif');
      height: 400px;
      width:100%;
      background-position: center center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }

  #estimate-results-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: start;
    width: 100%;
    margin-right: 50px;
  }

  #estimate-results-form-mobile {
    display: none;
    visibility: hidden;
  }

  .div-table-header {
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    padding-bottom: 10px;
    font-weight: 700
  }
  .results{
    border-bottom: #D8D8D8 1px solid;
    &:first-child {
      border-top: #D8D8D8 1px solid;
    }
    &:nth-child(odd) {
      background-color: #F7F7F7;
    }
    
    .div-table-cell {
      border-right: #D8D8D8 1px solid;
      &:last-child {
        border-right: none;
      }
      width:100%;
      display:flex;
      align-items:center;
      justify-content:center;
      
      
      padding: 10px;
      font-weight:600;
    }
  }

  @media (max-width: 576px) {
    #estimate-results-form {
      display: none !important;
      visibility: hidden;
    }
    #estimate-results-form-mobile {
      display: flex ;
      visibility: visible;
      flex-wrap: wrap;
      //justify-content: center;
      //align-items: center;

      
    }

  }

  @media(max-width: 1000px) {

    #estimate-results-form {
      margin-right: 15px !important;
      margin-left: 15px !important;
    }
    .overlay {
      bottom: 90px !important;
    }
  }
}


.ring span
{
  display:block;
  position:absolute;
  top:calc(50% - 2px);
  left:50%;
  width:50%;
  height:4px;
  background:transparent;
  transform-origin:left;
  animation:animate 2s linear infinite;
}
.ring span:before
{
  content:'';
  position:absolute;
  width:16px;
  height:16px;
  border-radius:50%;
  background:#1c5296;
  top:-6px;
  right:-8px;
  box-shadow:0 0 20px #1c5296;
}
.ring{
  position:absolute;
  top:25%;
  left:50%;
  transform:translate(-50%,-50%);
  width:150px;
  height:150px;
  background:transparent;
  /*border:3px solid #3c3c3c;*/
  border-radius:50%;
  text-align:center;
  line-height:150px;
  font-family:sans-serif;
  font-size:20px;
  color:#1c5296;
  letter-spacing:4px;
  text-transform:uppercase;
  text-shadow:0 0 10px #1c5296;
  box-shadow:0 0 20px rgba(0,0,0,.5);
}
.ring:before{
  content:'';
  position:absolute;
  top:0px;
  left:0px;
  width:100%;
  height:100%;
  border:3px solid transparent;
  border-top:3px solid #1c5296;
  border-right:3px solid #1c5296;
  border-radius:50%;
  animation:animateC 2s linear infinite;
}

@keyframes animateC
{
  0%
  {
    transform:rotate(0deg);
  }
  100%
  {
    transform:rotate(360deg);
  }
}
@keyframes animate
{
  0%
  {
    transform:rotate(45deg);
  }
  100%
  {
    transform:rotate(405deg);
  }
}

.mobile-result {
  width: 100%;
  border-left: 1px  solid #D8D8D8;
  background-color: #F7F7F7;
  padding:10px;
}
// label {
//   margin-bottom: unset;
// }
.mobile-table {
  width: 100%;
  height: 100%;
  margin: 10px;
  background-color: white;
}


.div-table-cell-mobile {
  //width:300px;
  display:flex;
  align-items:center;
  justify-content:center;

  border-top: 1px  solid #D8D8D8;


}
li {
  width:100%;
  margin-left:unset;
  margin-right: unset
}
h2 {
  font-size:22px;
  color:#1C5296;
  font-weight:700
}
p{
  margin-bottom: unset;
  text-align: center;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
a {
  color: #42b983;
}





</style>
